import { UIStore } from '../../../../../../../../../common/store/base/UIStore';

export class SettingUi extends UIStore {}
